import { css } from "@emotion/react";
import React from "react";

import { DefaultPageLayout } from "src/components/layout/DefaultPageLayout";
import { CardPageSection } from "src/components/layout/PageSection";
import { LoadingHandler } from "src/pages/Signup/LoginHandler";
import { RedirectHandler } from "src/pages/Signup/RedirectHandler";
import { SignUpAccountTypeSelector } from "src/pages/Signup/SignUpAccountTypeSelector";
import { colorCssVars } from "src/theme/color";
import { cssForMediaSize, MediaSize } from "src/theme/mediaQueries";
import { spacing } from "src/theme/spacing";

export const ChooseAccountPage: React.FCC = () => {
  return (
    <LoadingHandler>
      <RedirectHandler>
        <ChooseAccountPageContent />
      </RedirectHandler>
    </LoadingHandler>
  );
};

const ChooseAccountPageContent: React.FCC = () => {
  return (
    <DefaultPageLayout
      pageTitle="Choose account type"
      pageContentCss={cssForMediaSize({
        min: MediaSize.MEDIUM,
        css: css`
          padding-top: ${spacing.xl};
        `,
      })}
      metas={{
        "og:description":
          "New to Every.org? Sign up for a free account to get started.",
      }}
      css={[
        { backgroundColor: `var(${colorCssVars.background.normal})` },
        cssForMediaSize({
          min: MediaSize.MEDIUM,
          css: { backgroundColor: `var(${colorCssVars.background.faded})` },
        }),
      ]}
    >
      <CardPageSection
        cardProps={{
          shadow: true,
        }}
      >
        <SignUpAccountTypeSelector />
      </CardPageSection>
    </DefaultPageLayout>
  );
};
